export const passwordReset = {
  // État de vérification
  'passwordReset.verifying': 'Vérification du lien...',

  // État de lien invalide
  'passwordReset.invalidTitle': 'Lien invalide',
  'passwordReset.invalidDescription': 'Ce lien de réinitialisation est invalide ou a expiré.',
  'passwordReset.requestNew': 'Veuillez demander un nouveau lien de réinitialisation depuis la page de connexion.',
  'passwordReset.backToLogin': 'Retour à la connexion',

  // Lien valide - État de définition du mot de passe
  'passwordReset.setNewTitle': 'Nouveau mot de passe',
  'passwordReset.setNewDescription': 'Choisissez un nouveau mot de passe pour votre compte',
  'passwordReset.verified': 'Lien vérifié',
  'passwordReset.enterNew': 'Entrez votre nouveau mot de passe ci-dessous',

  // Étiquettes de formulaire
  'passwordReset.newPassword': 'Nouveau mot de passe',
  'passwordReset.newPasswordPlaceholder': 'Entrez votre nouveau mot de passe',
  'passwordReset.confirmPassword': 'Confirmer le mot de passe',
  'passwordReset.confirmPasswordPlaceholder': 'Confirmez votre nouveau mot de passe',

  // Exigences du mot de passe
  'passwordReset.requirementsTitle': 'Exigences du mot de passe :',
  'passwordReset.requirement1': 'Au moins 6 caractères',
  'passwordReset.requirement2': 'Mélange de lettres, chiffres et symboles',
  'passwordReset.requirement3': 'Évitez les mots de passe courants',

  // Boutons
  'passwordReset.updating': 'Mise à jour...',
  'passwordReset.updateButton': 'Mettre à jour le mot de passe',
  'passwordReset.cancel': 'Annuler',

  // Messages toast
  'passwordReset.mismatch': 'Les mots de passe ne correspondent pas',
  'passwordReset.mismatchDescription': 'Veuillez vous assurer que les deux champs de mot de passe sont identiques.',
  'passwordReset.tooShort': 'Mot de passe trop court',
  'passwordReset.tooShortDescription': 'Le mot de passe doit contenir au moins 6 caractères.',
  'passwordReset.success': 'Mot de passe mis à jour',
  'passwordReset.successDescription': 'Votre mot de passe a été modifié. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
  'passwordReset.failed': 'Échec de la réinitialisation',
  'passwordReset.failedWeak': 'Le mot de passe est trop faible. Veuillez choisir un mot de passe plus fort.',
  'passwordReset.failedExpired': 'Votre lien de réinitialisation a expiré. Veuillez demander une nouvelle réinitialisation.',
  'passwordReset.failedGeneric': 'Échec de la mise à jour du mot de passe. Veuillez réessayer.',
} as const;
